import { CoeditPolicies } from '../../editors/editorsReducer';

// Map co-edit option to policy
const getCoeditPolicyFromSelectValue = (value: string): CoeditPolicies => {
    if (value.toLowerCase().includes('start co-editing automatically')) {
        return CoeditPolicies.AlwaysCoedit;
    }
    if (value.toLowerCase().includes('ask the user')) {
        return CoeditPolicies.Ask;
    }

    return CoeditPolicies.NeverCoedit;
};

export { getCoeditPolicyFromSelectValue };
